module.exports = __webpack_public_path__ + "static/media/glyphicons-halflings-regular.e18bbf61.ttf";


//////////////////
// WEBPACK FOOTER
// ./html/assets/fonts/bootstrap/glyphicons-halflings-regular.ttf
// module id = 1003
// module chunks = 0